import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=576083ae&scoped=true"
import script from "./AddProduct.vue?vue&type=script&lang=js"
export * from "./AddProduct.vue?vue&type=script&lang=js"
import style0 from "./AddProduct.vue?vue&type=style&index=0&id=576083ae&prod&lang=scss&scoped=true"
import style1 from "./AddProduct.vue?vue&type=style&index=1&id=576083ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576083ae",
  null
  
)

export default component.exports